import React from 'react';
// import styles from './ErrorsTable.module.scss';

import moment from "moment";
import _ from "lodash";
import { $t } from "../../helpers/translator";
import api from "../../helpers/api";
import MultiSelect from "../miscellaneous/MultiSelect/MultiSelect";
import TimePeriodSelector from "../miscellaneous/TimePeriodSelector/TimePeriodSelector";
import DataTable from "../miscellaneous/DataTable/DataTable";
import { Link } from "react-router-dom";
import { getClinics, getErrorTypes } from "../../store/data-slice";
import { connect } from "react-redux";
import Input from "../miscellaneous/Input/Input";
import Timestamp from "../miscellaneous/Timestamp/Timestamp";


class ErrorsTable extends React.Component {
    // static propTypes = {
    //     /** Type of user connected to SmartClinic. used for routing links. (2: clinic, 3: chain) */
    //     userType: PropTypes.number,
    //     /** For presenting a specific clinic data. selection of clinic will be disabled. */
    //     clinicId: PropTypes.number,
    //     /** For presenting a specific patient data. */
    //     patientId: PropTypes.number,
    //     /** For presenting a specific staff data. */
    //     staffId: PropTypes.number,
    //     /** Header of table. Fallbacks to 'Treatments' */
    //     platformId: PropTypes.number,
    //     /** Header of table. Fallbacks to 'Treatments' */
    //     header: PropTypes.string,
    // }
    static defaultProps = {
        userType: 2,
        clinicId: 0,
        patientId: 0,
        staffId: 0,
        platformId: 0,
        header: $t('global.menu.platformErrors')
    }

    constructor(props) {
        super(props);

        this.state = {
            tableLoading: false,
            payload: {
                clinicId: this.props.clinicId ? this.props.clinicId : '',
                platformId: this.props.platformId ? this.props.platformId : '',
                errorId: '',
                startDate: moment().subtract(1, 'year'),
                endDate: moment(),
                sort: 'created_at',
                order: 'asc',
                search: '',
                page: 1,
                per_page: 10,
            },
            pagination: null,
            data: [],

            clinicOptions: [ {
                label: $t('global.service.allClinics'), value: ''
            }, ],
            selectedClinicOption: [ {
                label: $t('global.service.allClinics'), value: ''
            }, ],

            errorTypesOptions: [ {
                label: $t('global.service.allErrorTypes'), value: ''
            }, ],
            selectedErrorTypeOption: [ {
                label: $t('global.service.allErrorTypes'), value: ''
            }, ],
        };
    }

    async componentDidMount() {
        await this.getClinics();
        await this.getErrorsList();
        await this.getErrorTypesList();
    }

    async getClinics() {
        if (this.state.clinicId) {
            return;
        }

        let res = await this.props.dispatch(getClinics());

        let clinics = [ ...res ];
        clinics.unshift({
            value: '',
            label: $t('global.staff.allAreas'),
        })
        this.setState({ clinicOptions: clinics });
    }

    async getErrorTypesList() {
        let res = await this.props.dispatch(getErrorTypes());
        if (res) {
            let errorTypes = [ ...res ];
            errorTypes.unshift({
                value: '',
                label: $t('global.staff.allErrorTypes'),
            });

            this.setState({ errorTypesOptions: errorTypes });
        }
    }

    getAPIUrl() {
        let payload = { ...this.state.payload };
        payload.startDate = moment(payload.startDate).format('YYYY/MM/DD');
        payload.endDate = moment(payload.endDate).format('YYYY/MM/DD');

        return `service/platforms?&clinic_id=${payload.clinicId}&error_db_id=${payload.errorId}&platform_db_id=${payload.platformId}&sort=${payload.sort}&order=${payload.order}&search=${payload.search}&page=${payload.page}&per_page=${payload.per_page}&startDate=${payload.startDate}&endDate=${payload.endDate}`;
    }

    async getErrorsList() {
        this.setState({ tableLoading: true }, async () => {
            try {
                let res = await api.get(this.getAPIUrl());
                let pagination = null;
                let data = [];

                if (res && res.status === 200 && res.data.data) {
                    data = this.restructureData(res.data.data.data);
                    pagination = res.data.data.pagination;

                    this.setState({ platforms: [], pagination: pagination }, () => {
                        this.setState({
                            data: data,
                            pagination: pagination
                        });
                    })
                }
            } catch (e) {
                console.error('err get platforms:', e);
            } finally {
                this.setState({ tableLoading: false });
            }
        });
    }

    restructureData(data) {
        _.forEach(data, (v, k) => {
            v.created_at = <Timestamp time={ v.created_at } />
            v.delete = <div>delete</div>
            v.clinic_link = v.clinic_id ? <Link to={ `/clinic/${v.clinic_id}` }>{ v.clinic_name }</Link> : '';

            v.platform_id = v.platform_db_id ? <Link to={ `/equipment/platform/${v.platform_db_id}` }>{ v.machine_name }</Link> : v.machine_name;
            v.applicator_id = v.handle_id ? v.handle_name : '';
        });
        return data;
    }

    dataTableActionHandler(data) {
        if (data.key === 'page') {
            let payload = { ...this.state.payload };
            payload.page = data.value;

            this.setState({ payload: payload }, async () => {
                await this.getErrorsList();
            });
        } else if (data.key === 'header') {
            let payload = { ...this.state.payload };

            if (payload.sort === data.value) {
                payload.order = payload.order === 'desc' ? 'asc' : 'desc'
            }
            payload.sort = data.value;

            this.setState({ payload: payload }, async () => {
                await this.getErrorsList();
            });
        }
    }

    datesChangeHandler(data) {
        let payload = { ...this.state.payload };
        payload.startDate = data.startDate;
        payload.endDate = data.endDate;
        payload.page = 1;

        this.setState({ payload: payload }, async () => {
            await this.getErrorsList();
        });
    }

    searchHandler(e) {
        let payload = { ...this.state.payload };
        payload.search = e.target.value;
        payload.page = 1;

        this.setState({ payload: payload }, async () => {
            await this.getErrorsList();
        });
    }

    selectChangeHandler(name, data) {
        let payload = { ...this.state.payload };
        let selectedClinicOption = { ...this.state.selectedClinicOption };
        let selectedErrorTypeOption = { ...this.state.selectedErrorTypeOption };

        if (name === 'clinic') {
            payload.page = 1;
            payload.clinicId = data.value;
            selectedClinicOption = data;
        }

        if (name === 'errorType') {
            payload.errorId = data.value;
            payload.page = 1;
            selectedErrorTypeOption = data;
        }

        this.setState({
            payload: payload,
            selectedClinicOption: selectedClinicOption,
            selectedErrorTypeOption: selectedErrorTypeOption
        }, async () => {
            await this.getErrorsList();
        });
    }


    render() {
        let tableLoading = this.state.tableLoading;
        let data = this.state.data;
        let pagination = this.state.pagination;
        let tableSorted = {
            id: this.state.payload.sort,
            desc: this.state.payload.order === 'desc'
        }

        let tableHeaders = [
            {
                name: $t('global.service.dateAndTime'),
                id: 'created_at',
                clickable: true
            },
            (!this.props.clinicId && this.props.userType !== 2 ?
                {
                    name: $t('global.service.clinic'),
                    id: 'clinic_link',
                    clickable: true,
                    accessor: 'clinic_name'
                }
                :
                null),
            {
                name: $t('global.service.code'),
                id: 'code',
                clickable: true
            },
            {
                name: $t('global.service.title'),
                id: 'title',
                clickable: true
            },
            (!this.props.platformId ? {
                name: $t('global.service.platform'),
                id: 'platform_id',
                clickable: true,
                accessor: 'machine_name'
            } : null),
            {
                name: $t('global.service.applicator'),
                id: 'applicator_id',
                clickable: true,
                accessor: 'handle_name'
            },
        ];

        tableHeaders = tableHeaders.filter(function (el) {
            return el !== null;
        });

        return (
            <div className={ 'container' }>
                <div className={ 'box' }>
                    <div className={ 'alma-box' }>
                        <div className={ 'alma-box-header' }>
                            <div>
                                <h3 id="serviceErrorsTableHeader">{ this.props.header }</h3>
                            </div>
                        </div>
                        <div className={ 'alma-fields-row' }>
                            <div className={ 'alma-field-container' }>
                                <div className={ 'alma-field-header' }>{ $t('global.staff.selectTimePeriod') }:</div>
                                <TimePeriodSelector startDate={ this.state.payload.startDate }
                                    endDate={ this.state.payload.endDate }
                                    maxDate={ this.state.payload.startDate }
                                    hideQuarters
                                    onDatesChange={ this.datesChangeHandler.bind(this) } />
                            </div>
                            {
                                !this.props.clinicId && !this.props.platformId && this.props.userType !== 2 ?

                                    <div className={ 'alma-field-container' }>
                                        <div className={ 'alma-field-header' }>{ $t('global.service.byClinic') }</div>

                                        <MultiSelect
                                            options={ this.state.clinicOptions }
                                            selected={ this.state.selectedClinicOption }
                                            onValueChange={ (data) => this.selectChangeHandler('clinic', data) }
                                        />

                                    </div>
                                    :
                                    null
                            }

                            <div className={ 'alma-field-container' }>
                                <div className={ 'alma-field-header' }>{ $t('global.service.byError') }</div>

                                <MultiSelect
                                    options={ this.state.errorTypesOptions }
                                    selected={ this.state.selectedErrorTypeOption }
                                    onValueChange={ (data) => this.selectChangeHandler('errorType', data) }
                                />
                            </div>

                            <div className={ 'alma-field-container' }>
                                <div className={ 'alma-field-header' }>{ $t('global.service.search') }</div>
                                <Input name="search"
                                    delay={ 500 }
                                    // disabled={tableLoading}
                                    className={ `${'alma-input'}` }
                                    type="text"
                                    value={ this.state.payload.search }
                                    placeholder={ $t('global.service.searchForError') }
                                    onChange={ (e) => this.searchHandler(e) } />
                            </div>
                        </div>

                        <div>
                            <DataTable data={ data }
                                // childrenArrayName={'treatments'}
                                headers={ tableHeaders }
                                pagination={ pagination }
                                loading={ tableLoading }
                                sorted={ tableSorted }
                                apiUrl={ this.getAPIUrl() }
                                onAction={ (e) => this.dataTableActionHandler(e) }
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}


// export default ErrorsTable;

const mapStateToProps = (state) => ({
    state: state
});

export default connect(mapStateToProps)(ErrorsTable);
